export enum MobileVersionStatus {
    UNSUPPORTED = 'UNSUPPORTED', SUPPORTED = 'SUPPORTED', LATEST = 'LATEST'
}
